/* ============================================================
   Neural Expressive v2 — "Living Light" JS layer (2026-06-11)
   役割: ①オーロラリングの注入(シリーズ自動判定)
        ②マグネティックCTA(pointermove / scrollイベント不使用)
        ③view()非対応ブラウザの reveal / line フォールバック(IO)
        ④ビューポート進入時のオーロラ一瞬点灯(タッチ環境のLIVE感)
   Dawn のロジック・a11y は不変。全て加算・防御的に。
   軽量(~3KB) / 依存なし / defer。
   ============================================================ */
(function () {
  'use strict';

  var reduce = false;
  try {
    reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  } catch (e) {}
  if (reduce) return;

  var RING = '<span class="ne-aura__ring" aria-hidden="true"></span>';

  /** handle / href 文字列からシリーズ色を判定 */
  function seriesOf(str) {
    if (!str) return 'brand';
    try {
      str = decodeURIComponent(str).toLowerCase();
    } catch (e) {
      str = String(str).toLowerCase();
    }
    if (str.indexOf('premium') > -1) return 'premium';
    if (str.indexOf('pink') > -1 || str.indexOf('koso') > -1) return 'pink';
    if (str.indexOf('blue') > -1) return 'blue';
    return 'brand';
  }

  /** 対象要素にオーロラリングを注入(冪等) */
  function addAura(el, color, mode) {
    if (!el || el.dataset.neAura) return;
    el.dataset.neAura = '1';
    el.classList.add('ne-aura', 'ne-aura--' + color, 'ne-aura--' + mode);
    el.insertAdjacentHTML('afterbegin', RING);
  }

  /* ---------- ① オーロラ注入 ---------- */
  function initAuras(root) {
    root = root || document;

    /* ヒーローCTA(主ボタン) = ブランドオーロラ常時 */
    root.querySelectorAll('.ne-hero__btns .button:not(.button--secondary)').forEach(function (b) {
      addAura(b, 'brand', 'on');
    });

    /* PDP 購入ボタンのオーロラは撤去(2026-07-04):
       横長ボタンでは彗星弧の一部しか見えず「途切れた線」に見えるため。
       カードのホバー点灯・ヒーローCTAは維持 */

    /* 商品カードのオーロラは撤去(2026-07-15):
       回転リングは安っぽく見えるためユーザー判断で廃止。
       代替の高級ホバー(ズーム+裏面+ヘアラインリング)は nx-cards.css 側 */

    /* ニュースレター入力 = フォーカスで点灯 */
    root.querySelectorAll('.newsletter-form__field-wrapper').forEach(function (f) {
      addAura(f, 'brand', 'focus');
    });
  }

  /* ---------- ② マグネティック(pointer fine のみ) ---------- */
  function initMagnetic() {
    if (!window.matchMedia('(pointer: fine)').matches) return;
    var targets = document.querySelectorAll('.ne-hero__btns .button, .product-form__submit, [data-ne-magnetic]');
    targets.forEach(function (el) {
      var raf = 0;
      el.addEventListener('pointerenter', function () {
        el.classList.add('ne-magnetized');
      });
      el.addEventListener('pointermove', function (ev) {
        var r = el.getBoundingClientRect();
        var x = (ev.clientX - r.left - r.width / 2) / r.width;
        var y = (ev.clientY - r.top - r.height / 2) / r.height;
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          el.style.transform = 'translate3d(' + (x * 7).toFixed(1) + 'px,' + (y * 5).toFixed(1) + 'px,0)';
        });
      });
      el.addEventListener('pointerleave', function () {
        cancelAnimationFrame(raf);
        el.style.transform = '';
        window.setTimeout(function () {
          el.classList.remove('ne-magnetized');
        }, 180);
      });
    });
  }

  /* ---------- ③ view() 非対応の reveal/line フォールバック ---------- */
  function initRevealFallback() {
    if (window.CSS && CSS.supports && CSS.supports('animation-timeline: view()')) return;
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('ne-in');
            io.unobserve(e.target);
          }
        });
      },
      { rootMargin: '0px 0px -12% 0px' },
    );
    document.querySelectorAll('[data-ne-reveal], .ne-line').forEach(function (el) {
      io.observe(el);
    });
  }

  /* ---------- ④ 進入時の一瞬点灯(タッチ環境のLIVE感) ---------- */
  function initPeek() {
    if (window.matchMedia('(hover: hover)').matches) return;
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          var el = e.target;
          el.classList.add('ne-aura--peek');
          window.setTimeout(function () {
            el.classList.remove('ne-aura--peek');
          }, 2100);
          io.unobserve(el);
        });
      },
      { threshold: 0.55 },
    );
    document.querySelectorAll('.ne-aura--hover').forEach(function (el) {
      io.observe(el);
    });
  }

  /* ---------- ⑤ 波ディバイダのスクロール連動モーフ(ホーム以外) ----------
     ホームは ne-experience.js(GSAP ScrollTrigger)が同じ path[data-d2] を
     スクラブするため、GSAPベンダーが読み込まれるページでは何もしない。
     ここは依存ゼロの軽量版: d1→d2 の数値を線形補間し、
     ビューポート通過進行度に sin を掛けて ∪→∩→∪ の往復にする(トップと同じ体験) */
  var waveMorphItems = [];
  var waveMorphBound = false;
  var waveTicking = false;
  function wavePaint() {
    waveTicking = false;
    var vh = window.innerHeight || 1;
    waveMorphItems.forEach(function (it) {
      var r = it.host.getBoundingClientRect();
      if (r.bottom < 0 || r.top > vh) return; // 画面外は触らない
      var progress = (vh - r.top) / (vh + r.height); // 0(下端進入)→1(上端退場)
      if (progress < 0) progress = 0;
      else if (progress > 1) progress = 1;
      var k = Math.sin(progress * Math.PI); // 往復(中央で最大反転)
      if (Math.abs(k - it.lastK) < 0.003) return;
      it.lastK = k;
      var d = it.parts[0];
      for (var i = 0; i < it.n1.length; i++) {
        d += (it.n1[i] + (it.n2[i] - it.n1[i]) * k).toFixed(1) + it.parts[i + 1];
      }
      it.el.setAttribute('d', d);
    });
  }
  function onWaveScroll() {
    if (waveTicking) return;
    waveTicking = true;
    window.requestAnimationFrame(wavePaint);
  }
  function initWaveMorph() {
    waveMorphItems = [];
    if (document.querySelector('script[src*="ne-vendor-gsap"]')) return; // ホーム=GSAP担当
    var NUM_RE = /-?(?:\d+\.?\d*|\.\d+)/g; // .5 / -.5 形式も許容(指数表記は対象外)
    document.querySelectorAll('.nx-wave path[data-d2]').forEach(function (p) {
      var d1 = p.getAttribute('d');
      var d2 = p.getAttribute('data-d2');
      if (!d1 || !d2) return;
      var n1 = (d1.match(NUM_RE) || []).map(Number);
      var n2 = (d2.match(NUM_RE) || []).map(Number);
      if (!n1.length || n1.length !== n2.length) return;
      // コマンド骨格(数値以外)が一致しない組はモーフ不可として除外
      if (d1.split(NUM_RE).join('|') !== d2.split(NUM_RE).join('|')) return;
      waveMorphItems.push({
        el: p,
        host: p.closest('.nx-wave') || p.ownerSVGElement,
        n1: n1,
        n2: n2,
        parts: d1.split(NUM_RE), // 数値以外の骨格(コマンド/区切り)
        lastK: -1,
      });
    });
    if (!waveMorphItems.length) return;
    if (!waveMorphBound) {
      waveMorphBound = true;
      window.addEventListener('scroll', onWaveScroll, { passive: true });
      window.addEventListener('resize', onWaveScroll, { passive: true });
    }
    onWaveScroll(); // 初期位置(ページ中腹リロード)にも追従
  }

  /* ---------- ⑥ 全ページ・上質フェードイン(2026-07-18) ----------
     ホーム(GSAP演出あり)は除外。初期ビューポート内の要素は隠さない(LCP/no-JS安全)。
     - 複数セクション構成: 画面外の .shopify-section を丸ごとじんわり
     - 縦長単一セクションLP(nx系): inner直下ブロック単位・長いUL/OLはLI単位に展開
     - 遷移完了後は transform を解除(sticky等の座標系を汚さない) */
  function firstRealChild(el) {
    for (var i = 0; el && i < el.children.length; i++) {
      var t = el.children[i].tagName;
      if (t !== 'LINK' && t !== 'SCRIPT' && t !== 'STYLE') return el.children[i];
    }
    return null;
  }
  function initSectionReveal() {
    if (document.querySelector('script[src*="ne-vendor-gsap"]') || document.querySelector('.ne-hero')) return;
    var main = document.getElementById('MainContent') || document.querySelector('main');
    if (!main) return;
    var vh = window.innerHeight || 1;
    var targets = [];
    function push(el) {
      if (!el) return;
      var r = el.getBoundingClientRect();
      if (r.top < vh * 0.92 || r.height < 8) return; // 初期画面内は隠さない
      targets.push(el);
    }
    var secs = main.querySelectorAll(':scope > .shopify-section');
    Array.prototype.forEach.call(secs, function (sec) {
      if (sec.getBoundingClientRect().height > vh * 1.2) {
        var host = firstRealChild(sec);
        var inner = firstRealChild(host);
        var blocks = inner ? inner.children : [];
        Array.prototype.forEach.call(blocks, function (b) {
          if ((b.tagName === 'UL' || b.tagName === 'OL') && b.getBoundingClientRect().height > vh * 0.6) {
            Array.prototype.forEach.call(b.children, push);
          } else {
            push(b);
          }
        });
      } else {
        push(sec);
      }
    });
    if (!targets.length) return;
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          /* 高速スクロールで既に通過(上方へ抜けた)要素も取りこぼさず表示する */
          if (!e.isIntersecting && e.boundingClientRect.top >= 0) return;
          e.target.classList.add('nx-fadein-in');
          io.unobserve(e.target);
        });
      },
      /* 上側を大きく拡張: 1フレームで画面を通過した要素も「交差中」となり
         コールバック無発火のまま非表示で残る取りこぼしを防ぐ */
      { rootMargin: '2000% 0px -8% 0px' },
    );
    targets.forEach(function (el) {
      el.classList.add('nx-fadein');
      el.addEventListener('transitionend', function te(ev) {
        if (ev.propertyName !== 'transform') return;
        el.classList.add('nx-fadein-done');
        el.removeEventListener('transitionend', te);
      });
      io.observe(el);
    });
  }

  function boot() {
    initAuras(document);
    initMagnetic();
    initRevealFallback();
    initPeek();
    initWaveMorph();
    initSectionReveal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* Shopify テーマエディタのセクション再描画にも追従 */
  document.addEventListener('shopify:section:load', function (ev) {
    initAuras(ev.target);
    initWaveMorph(); // 波を含む再描画に備えて再スキャン(GSAPページ内では自動スキップ)
  });
})();
